import { InvoicesWorkspace } from "@/features/invoices/components/InvoicesWorkspace";

export function ReceiptsPage() {
  return (
    <InvoicesWorkspace
      variant="receipts"
      exportKind="receipt"
      lockStatusToPaid
      title="Download Receipts"
      breadcrumbSuffix="Download Receipts"
      tableTitle=""
      defaultStatus="paid"
      compactDownloadLayout
    />
  );
}
